<template>
    <div>
      <Pos_inventory_edit/>
    </div>
  </template>
  
  <script>
  import Pos_inventory_edit from "@/components/adminArin/pos_system/warehouse/inventory/Pos_inventory_edit";
  export default {
    name: "PosInventoryEdit",
    components: {
      Pos_inventory_edit
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  